module.exports = __webpack_public_path__ + "img/Terminal Page Puerto Bahia.7b21ac3d.jpg";